import React, { useState } from 'react';
import Tool from '../../Tool/Tool';
import { useGlobalVariablesContext } from '../../../context/GlobalVariablesContext';
import { useTranslation } from 'react-i18next';
import TabNavigation from '../../Bootstrap/Tabs/TabNavigation';
import TabContent from '../../Bootstrap/Tabs/TabContent'; 
import CatastroData from '../CatastroData/CatastroData';
import CatastroReferencia from '../CatastroReferencia/CatastroReferencia';

import './CadastroSelector.css';

const CadastroSelector = () => {
  const [activeTab, setActiveTab] = useState('map');

  const { config, layerCadastro } = useGlobalVariablesContext();
  const { t } = useTranslation();
  if (!config) return null;

  const tabs = [
    { label: t('Map'), value: 'map' },
    { label: t('Ref'), value: 'ref' },
  ];

  const contents = [
    { value: 'ref', component: <CatastroData /> },
    { value: 'map', component: <CatastroReferencia
      title={t('Referencia Catastral')}
      buttonName='catastral'
      buttonText={layerCadastro ? t('Desactivar capa de catastro') : t('Activar capa de catastro')}
      toggleable
      type='isSingle'

    /> },
  ];

  const sidebarContent = (
    <div className="layer-selector-container">
      <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />
      <TabContent activeTab={activeTab} contents={contents} />
    </div>
  );

  return (
    <Tool
      id="cadastro_button"
      type="toggleable"
      icon='bi bi-buildings'
      label={t('Catastro')}
      sidebarTitle={t('Catastro')}
      hasSidebar
      lockActive={Boolean(layerCadastro)}
      sidebarContent={sidebarContent}
    />
  );
}

export default CadastroSelector;